import { deserializeIncome } from './deserialize-income';
import { serializeIncome } from './serialize-income';
import {
  IncomeDataT,
  IncomeRequestT,
  IncomeResponseT,
} from '../../types';
import { TransformT } from '../../types/transform';

export const incomeTransform: TransformT<IncomeDataT, IncomeResponseT, IncomeRequestT> = {
  deserialize: deserializeIncome,
  serialize: serializeIncome,
};
